<script>
export default {
  data() {
    return {
      menuIsOpen: false,
    };
  },
};
</script>

<template>
  <header class="theHeader">
    <h1 class="theHeader_title">
      <ion-icon class="theHeader_title_icon" :src="require('@/assets/img/logo.svg')" />
      <teleport-target name="title" />
    </h1>
  </header>
</template>

<style lang="scss" scoped>
$angle: 15px;

.theHeader {
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: (64px + $angle);
  background: map.get($colors,'light');

  &::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 0 $angle 100vw;
    border-color: transparent transparent #ffffff transparent;
  }

  &_title {
    display: flex;
    align-items: center;
    padding-bottom: $angle;
    font-size: 32px;
    font-weight: 700;
    color: map.get($colors,'black');

    &_icon {
      flex: none;
      margin-right: 8px;
    }
  }

  @include touch() {
    align-items: flex-start;
    padding-left: 20px;

    &_title {
      font-size: 24px;
    }
  }
}
</style>
